import './AvatarBadge.css';

function initialsFrom(text) {
  if (!text) return '—';
  const parts = String(text).replace(/[._-]+/g, ' ').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '—';
  const first = parts[0][0] || '';
  const second = parts.length > 1 ? parts[parts.length - 1][0] : '';
  return (first + second).toUpperCase();
}

/**
 * Mockup parity for `.avatar-badge` — 32px round chip with 1-2 initial letters.
 *   tone="customer" (blue gradient) | "rep" (indigo gradient) | "neutral"
 */
export function AvatarBadge({ name, initials, tone = 'customer', size = 32 }) {
  const text = initials || initialsFrom(name);
  const style = size === 32 ? undefined : { width: size, height: size, fontSize: Math.max(10, Math.round(size * 0.34)) };
  return (
    <span className={`ui-avatar-badge ui-avatar-badge--${tone}`} style={style} aria-hidden="true">
      {text}
    </span>
  );
}
